import { OLAF } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActionCardBanner = ({
  bannerText,
  bannerStyle
}) => {
  let headerColorToken = 'fill-alert-default';
  let bannerIcon = 'remove';
  if (bannerStyle === 'success') {
    headerColorToken = 'fill-positive-pressed';
    bannerIcon = 'success';
  }
  if (bannerStyle === 'success_no_icon') {
    headerColorToken = 'fill-positive-pressed';
    bannerIcon = '';
  }
  if (bannerStyle === 'warning') {
    headerColorToken = 'fill-caution-pressed';
    bannerIcon = 'warning';
  }
  return /*#__PURE__*/_jsx(View, {
    paddingBlock: "100",
    paddingInline: "200",
    backgroundColor: headerColorToken,
    textAlign: "center",
    children: /*#__PURE__*/_jsx(UITruncateString, {
      children: /*#__PURE__*/_jsxs(Text, {
        color: "text-primary-on-fill-default",
        as: "strong",
        typography: "heading-50",
        children: [bannerIcon && /*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-1",
          color: OLAF,
          name: bannerIcon,
          size: 12
        }), bannerText]
      })
    })
  });
};
export default ActionCardBanner;